//--- React
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Empty, Row, Table, Divider } from "antd";
//--- Project
import { UNITS } from "components/Common/Constants";
import SPEEDOMETER from "assets/images/icons/Speedometer.svg";

const SpeedMap = () => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);

  const columns = [
    {
      title: "Mode",
      dataIndex: "mode",
      key: "mode",
      width: "35%",
      render: (_, record, dataIndex) => {
        return (
          <div className="left w100">
            <div className="align-center w100">
              <div className={"mode" + dataIndex} />
              <div className="mode-text">{record.mode}</div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Frequent Speed",
      dataIndex: "speed",
      key: "speed",
      width: "40%",
      render: (_, record) => {
        return `${record.speed} ${UNITS.KM_PER_HR}`;
      },
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      render: (_, record) => {
        return `${record.distance} ${UNITS.KM}`;
      },
    },
  ];

  const innerContent = (
    title,
    minTitle,
    minValue,
    maxTitle,
    maxValue,
    unit
  ) => {
    return (
      <Row className="border pd1 h100">
        <Col span={24} className="text-center highlight-title">
          {title}
        </Col>
        <Col span={24} className="mt1 mb025">
          <Row justify={"space-evenly"} className="h100">
            <Col>
              {minValue ? (
                <div>
                  <span className="avg-count">{minValue}</span>
                  <span className="card-sub-text ml015">{unit}</span>
                </div>
              ) : (
                <div className="disabled ml025 mb05">NA</div>
              )}
              <div className="card-sub-text text-center">{minTitle}</div>
            </Col>
            {maxTitle ? (
              <>
                <Col>
                  <Divider className="h100" type={"vertical"} />
                </Col>
                <Col>
                  {maxValue ? (
                    <div>
                      <span className="avg-count">{maxValue}</span>
                      <span className="card-sub-text ml015">{unit}</span>
                    </div>
                  ) : (
                    <div className="disabled ml025 mb05">NA</div>
                  )}
                  <div className="card-sub-text text-center">{maxTitle}</div>
                </Col>
              </>
            ) : null}
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Row gutter={[16, 16]} className="speed">
      <Col span={24}>
        <Row gutter={[16, 16]} align={"middle"} className="mt1">
          <Col className="align-center">
            <img src={SPEEDOMETER} alt="view" height={24} />
          </Col>
          <Col className="sub-title">Speed Analytics</Col>
        </Row>
      </Col>

      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={24} lg={12}>
            <div className="w100 h100 border">
              {tripSummary?.tripModeStats?.length > 0 ? (
                <Table
                  className="mode-table"
                  rowKey={(record) => record.mode}
                  columns={columns}
                  dataSource={tripSummary?.tripModeStats}
                  pagination={false}
                  scroll={{ x: "100%", y: 140 }}
                />
              ) : (
                <div className="pd1">
                  <Empty />
                </div>
              )}
            </div>
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Motor Speed",
              "Avg",
              tripSummary?.avgMotorSpeed,
              "Max",
              tripSummary?.maxMotorSpeed,
              UNITS.KM_PER_HR
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "GPS Speed",
              "Avg",
              tripSummary?.avgGpsSpeed,
              "Max",
              tripSummary?.maxGpsSpeed,
              UNITS.KM_PER_HR
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SpeedMap;
